
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import AddOrUpdate from './address-book-add-or-update'
	import Template from "@/template.vue";
	@Component({
		name: 'contractinfo',
		components:{
			Template,
			AddOrUpdate
		}
	})
	export default class contractinfo extends Vue {
		addressBookVisible=false
		currentNo: number = 1;
		pageSize: number = 10;
		pageTotal: number = 0;
		searchForm= {
			name:'',
			gdid: '',
            bmid: '',
			zrrgh: '',
			zrrxm: '',
			dhhm: '',
			dh: ''
		}
		addressBookList=[]
		loading: boolean = false;
		dataListSelections=[];
		gdList = [];
		depts = [];
		deptdisable = false;

		created() {
			this.searchData();
			this.getDepts();
			this.getGd();
		}

		searchData() {
			this.searchForm.page = this.currentNo
			this.searchForm.pagesize = this.pageSize
			this.loading = true;
			this.$request({
					url: '/bjba/addressBook/page',
					method: 'get',
					params: this.searchForm
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.addressBookList = data.data.content;
						this.pageTotal = data.data.totalElements
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(error)
				});
		}

		getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }
            }).then(res => {
                that.depts = res.data
                if(this.depts && this.depts[0]) {
                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;
                        if(zw) {
                            if(zw=='01'||zw=='02'||zw=='03') {
                                this.searchForm.bmid = that.depts[0].bmid
                                this.deptdisable = true
                            }
                        }
                    }
                }
            })
        }

		getGd() {
            this.$request.get('/bjba/map/queryAll').then(res => {
                this.gdList = res.data.data
            })
        }

		handleSizeChange(val: number) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val: number) {
			this.currentNo = val;
			this.searchData();
		}

		changeIndex() {
			this.currentNo =1
		}
		
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}

		addOrUpdate(val: any) {
			this.addressBookVisible = true
			this.$nextTick(() => {
				this.$refs.addressbook.init(val)
			})
		}

		deleteHandle (id) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			if(!ids || ids.length==0) return
			this.$confirm(`确定进行[删除]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/addressBook/delete`,
					method: 'post',
					data: ids
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.searchData()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}
	}
